import React from 'react'

function TermsOfService() {
  return (
    <div>TermsOfService</div>
  )
}

export default TermsOfService